module.exports = __webpack_public_path__ + "img/jalisco.efe2a11b.png";